import { generatedReportsRouteConfig } from './generatedReports';
import { myReportsRouteConfig } from './myReports';
import { archivedReportsRouteConfig } from './archivedReports';
import { scheduledReportsRouteConfig } from './scheduledReports';
import { packageReportsRouteConfig } from './packageReports';


export default function routes($routeProvider, $locationProvider) {
  $locationProvider.hashPrefix('');
  $routeProvider.when('/reports', generatedReportsRouteConfig)
    .when('/reports/generated-reports', generatedReportsRouteConfig)
    .when('/reports/my-reports', myReportsRouteConfig)
    .when('/reports/archived-reports', archivedReportsRouteConfig)
    .when('/reports/schedule-reports', scheduledReportsRouteConfig)
    .when('/reports/package-reports', packageReportsRouteConfig);
}

routes.$inject = ['$routeProvider', '$locationProvider'];
console.log('app.components.reports.routes loaded');
